import { Navigate, useLocation } from 'react-router-dom';
import { FC } from 'react';

import { useAppSelector } from 'hooks';

import { ClientStatus } from 'utils/constants';

type AuthRouteProps = {
	children: JSX.Element;
	isAllowed: boolean;
	redirectPath?: string;
};

export const AuthRoute: FC<AuthRouteProps> = ({ children, isAllowed, redirectPath }) => {
	const user = useAppSelector((state) => state.user.entity);
	const location = useLocation();
	const { state }: any = location;

	const isActive = user.status === ClientStatus.ACTIVE;
	const isRegistration = user.status === ClientStatus.INCOMPLETE;

	isAllowed = state?.isKyc ? true : isAllowed;

	const to = redirectPath
		? redirectPath
		: isRegistration
		? '/register'
		: isActive
		? '/account/overview'
		: '/';

	if (!isAllowed) {
		return <Navigate to={to} state={{ from: location }} />;
	}

	return children;
};
